module.exports = __webpack_public_path__ + "img/3화_13(1).223f3372.jpg";